<template>
  <div class="pure-trading-pure" :class="$t('InsitutionService.box-name')">
    <page-navigate></page-navigate>
    <div class="technologyHead flex items-start">
      <div class="technologyHeadMain">
        <h1 class="super_large-72_bold md-title-32_bold word1">金融科技</h1>
        <h2 class="subtitle-20_regular md-body-14_regular word2">EBC高性能架构和独特算法，提供极速订单执行和低延迟聚合，助力交易者掌控市场先机</h2>
        <a href="{$register}" target="_blank" class="primary-default_large technologyHeadBtn">
          <span class="word3">开始交易</span>
          <span class="iconfont icon-right"></span>
        </a>
      </div>
      <img src="@/assets/image/technology/technologyModel.png" alt="" class="technologyHeadModel">
    </div>
    <div class="techPowerTrade">
      <h2 class="title-48_bold md-title-24_bold scroll-fade-up word4">科技赋能交易</h2>
      <h3 class="subtitle-20_regular md-footnote-regular_12 scroll-fade-up word5">
        部署于伦敦、纽约、新加坡、东京、香港的超高速独立专线服务器，通过对等网络连接，覆盖全球交易节点</h3>
      <div class="mobile">
        <a href="{$register}" target="_blank"
          class="primary-default_medium techPowerTradeBtn cursor-pointer scroll-fade-up word3">开始交易</a>
      </div>
      <div class="techPowerTradeMain">
        <div id="worldMap">
          <img src="@/assets/image/technology/earthMap.jpg" alt="">
          <div class="pointerList">
            <div class="pointer pointer1"></div>
            <div class="pointer pointer2"></div>
            <div class="pointer pointer3"></div>
            <div class="pointer pointer4"></div>
            <div class="pointer pointer5"></div>
            <div class="pointerShadow pointerShadow1"></div>
            <div class="pointerShadow pointerShadow2"></div>
            <div class="pointerShadow pointerShadow3"></div>
            <div class="pointerShadow pointerShadow4"></div>
            <div class="pointerShadow pointerShadow5"></div>
          </div>
          <div class="wordList">
            <div class="word word1 footnote-regular_12">纽约</div>
            <div class="word word2 footnote-regular_12">伦敦</div>
            <div class="word word3 footnote-regular_12">新加坡</div>
            <div class="word word4 footnote-regular_12">香港</div>
            <div class="word word5 footnote-regular_12">东京</div>
          </div>
        </div>

        <div class="techPowerTradeStatic flex items-center ">
          <div class="staticPart">
            <div class="title-48_bold md-title-24_bold" id="number1"></div>
            <div class="body-14_regular md-footnote-regular_12 scroll-fade-up word6">银行级原始点差</div>
          </div>
          <div class="staticPart">
            <div class="title-48_bold md-title-24_bold" id="number2"></div>
            <div class="body-14_regular md-footnote-regular_12 scroll-fade-up word7">每秒最高聚合订单</div>
          </div>
          <div class="staticPart">
            <div class="title-48_bold md-title-24_bold" id="number3"></div>
            <div class="body-14_regular md-footnote-regular_12 scroll-fade-up word8">数据传输稳定性</div>
          </div>
          <div class="staticPart">
            <div class="title-48_bold md-title-24_bold" id="number4"></div>
            <div class="body-14_regular md-footnote-regular_12 scroll-fade-up word9">平均执行速度</div>
          </div>
        </div>
      </div>
      <div class="pc">
        <a href="{$register}" target="_blank"
          class="primary-default_medium techPowerTradeBtn cursor-pointer scroll-fade-up word3">开始交易</a>
      </div>
    </div>
    <div class="orderTransfer text-center">
      <div class="contentBox">
        <h2 class="title-48_bold md-title-24_bold scroll-fade-up word10">价格发现&订单传输</h2>
        <div class="orderTransferModel scroll-fade-up">
          <img src="@/assets/image/technology/orderTransferModel.png" alt="">
        </div>
        <div class="fake-scrollbar mobile scroll-fade-up">
          <div class="fake-thumb"></div>
        </div>
      </div>
    </div>
    <div class="tradeBlackBox" id="tradeBlack">
      <div class="contentBox">
        <h2 class="title-48_bold md-title-24_bold scroll-fade-up word11">交易黑盒</h2>
        <h3 class="subtitle-20_regular md-footnote-regular_12 scroll-fade-up word12">让87.6%以上的订单成交于更优价格</h3>
        <div class="mobile scroll-fade-up">
          <a class="secondary-white-default_large mobileTradeBlackBtn cursor-pointer " href="{$register}"
            target="_blank">
            <span class="word14">展示交易时段</span>
            <span class="iconfont icon-right"></span>
          </a>
        </div>

        <div class="tradeBlackStickyPage firstPage flex items-center justify-between scroll-fade-up">
          <div class="pageContent">
            <div class="innerPagenavigation flex">
              <div class="active"></div>
              <div></div>
            </div>
            <div class="pageDescription md-content-14_regular subtitle-20_regular word13">
              EBC交易黑盒，基于数千万次的历史交易数据和大数据模型，依托精准抛单算法，匹配更适合交易者属性的LP，达成最优的成交价格。
            </div>
            <a class="secondary-white-default_large tradeBlackBtn cursor-pointer" href="{$register}" target="_blank">
              <span class="word14">展示交易时段</span>
              <span class="iconfont icon-right"></span>
            </a>
          </div>
          <div class="pageModel">
            <img src="@/assets/image/technology/blackBoxModel1.png" alt="">
          </div>
        </div>
        <div class="tradeBlackStickyPage secondPage flex items-center justify-between scroll-fade-up">
          <div class="pageContent">
            <div class="innerPagenavigation flex">
              <div></div>
              <div class="active"></div>
            </div>
            <div class="pageDescription md-content-14_regular subtitle-20_regular word25">
              经过验证：在价格优化率、订单成交率以及算法稳定性方面，EBC交易黑盒远远优于传统交易系统。
            </div>
            <a class="secondary-white-default_large tradeBlackBtn cursor-pointer" href="{$register}" target="_blank">
              <span class="word14">展示交易时段</span>
              <span class="iconfont icon-right"></span>
            </a>
          </div>
          <div class="pageModel">
            <div class="locationWord locationWord1">价格改进率(%)</div>
            <div class="locationWord locationWord2">订单成交率(%)</div>
            <img src="@/assets/image/technology/tradeBlackBoxModel2.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="liquidityDepth text-center">
      <div class="contentBox">
        <h2 class="title-48_bold md-title-24_bold scroll-fade-up word26">流动性深度</h2>
        <h3 class="subtitle-20_regular md-footnote-regular_12 scroll-fade-up word27">
          多层级报价深度，以清晰的报价和交易量，帮助投资者洞悉市场流动性，确保交易透明可靠</h3>
        <div class="floatTab flex justify-center items-center scroll-fade-up">
          <div class="tabItem text-center cursor-pointer body-16_regular active word1">
            衍生品
          </div>
          <div class="tabItem text-center cursor-pointer body-16_regular word2">
            贵金属及能源
          </div>
          <div class="tabItem text-center cursor-pointer body-16_regular word3">
            全球股指
          </div>
          <div class="tabItem text-center cursor-pointer body-16_regular word4">
            美国股票
          </div>
          <div class="tabItem text-center cursor-pointer body-16_regular word4">
            ETF
          </div>
          <!-- <div class="tabItem text-center cursor-pointer body-16_regular word4">
                    数字资产
                </div> -->
        </div>
        <div class="mobile scrollTabWrapper scroll-fade-up">
          <div class="scrollTab flex justify-center items-center">
            <div class="tabItem text-center cursor-pointer md-footnote-regular_12 active word1">
              衍生品
            </div>
            <div class="tabItem text-center cursor-pointer md-footnote-regular_12 word2">
              贵金属及能源
            </div>
            <div class="tabItem text-center cursor-pointer md-footnote-regular_12 word3">
              全球股指
            </div>
            <div class="tabItem text-center cursor-pointer md-footnote-regular_12 word4">
              美国股票
            </div>
            <div class="tabItem text-center cursor-pointer  md-footnote-regular_12 word4">
              ETF
            </div>
            <!-- <div class="tabItem text-center cursor-pointer md-footnote-regular_12 word4">
                    数字资产
                </div> -->
          </div>
        </div>
        <div id="pageOverLay"></div>
        <product-module-new />
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import { mapGetters } from "vuex";
export default {
  mixins: [fadeAnimate],
  data() {
    return {

    }
  },

  computed: {
    ...mapGetters(["signupUrl"]),
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      function move(dom, index) {
        const el = document.querySelector(dom);
        if (!el) return;

        const rect = el.getBoundingClientRect();
        const topOuter = window.scrollY + rect.top;          // 元素上边缘到文档顶部
        const topCenter = topOuter + rect.height / 2+ 10;        // 元素中心到文档顶部
        const viewportCenter = window.innerHeight / 2 ;       // 视口中心线

        let y;
        if (index === 1) {
          y = topOuter;                                      // 上边缘贴视口顶部
        } else {
          y = topCenter - viewportCenter;                    // 中心线对齐视口中心
        }

        window.scrollTo({ top: y, behavior: 'smooth' });
      }
      document.querySelector('.firstPage .innerPagenavigation').addEventListener('click', () => {
        move('.tradeBlackBox', 2)
      })

      document.querySelector('.secondPage .innerPagenavigation').addEventListener('click', () => {
        move('.tradeBlackBox', 1)
      })
      function imageSyncFakeScroll(wrapperSel) {
        const wrap = document.querySelector(wrapperSel);
        const scroll = wrap.querySelector(".orderTransferModel");
        const track = wrap.querySelector(".fake-scrollbar");
        const thumb = wrap.querySelector(".fake-thumb");

        function sync() {
          const w = scroll.clientWidth;
          const sw = scroll.scrollWidth;
          const l = scroll.scrollLeft;
          const maxL = sw - w;
          if (maxL <= 0) {
            thumb.style.width = "100%";
            return;
          }

          const thumbW = (w / sw) * track.clientWidth;
          thumb.style.width = thumbW + "px";
          const maxMove = track.clientWidth - thumbW;
          thumb.style.transform = `translateX(${(l / maxL) * maxMove}px)`;
          if (l <= 0) {
            wrap.classList.add("noScroll");
          } else {
            wrap.classList.remove("noScroll");
          }
        }


        scroll.addEventListener("scroll", sync, { passive: true });

        sync();
      }

      imageSyncFakeScroll(".orderTransfer");

      function numberAnimate() {
        const cfg = {
          2: [1000, 0, "1,000", "+"], // 1 000
          4: [20, 0, "20", "ms"], // 20
          3: [98.75, 0, "98.75", "%"], // 98.75%
          1: [0, 1, "0.0", "pips"], // 6.0 → 0.0（倒计时）
        };

        Object.keys(cfg).forEach((key) => {
          const [end, decimals, prefix, suffix] = cfg[key];
          const $el = $(
            window.matchMedia("(max-width: 996px)").matches
              ? `#number${key}`
              : `#number${key}`
          );
          $({ countNum: decimals === 1 ? 60 : 0 }).animate(
            { countNum: end },
            {
              duration: 700,
              easing: "linear",
              step() {
                const val =
                  decimals > 0
                    ? (this.countNum / 10).toFixed(1)
                    : Math.floor(this.countNum);
                $el.eq(0).text(val);
              },
              complete() {
                const final = prefix;
                $el.eq(0).text(final + suffix);
              },
            }
          );
        });
      }

      const technogolyStatic = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              setTimeout(() => {
                numberAnimate();
              }, 500);
              technogolyStatic.disconnect(e.target);
            }
          });
        },
        { threshold: 0.5 }
      );
      technogolyStatic.observe(document.querySelector(".techPowerTradeStatic"));

      // 用法

      document.querySelector(".floatTab").classList.add("scroll-fade-up");
      document.querySelector(".scrollTabWrapper").classList.add("scroll-fade-up");

      const setTabActIdx = (idx, e) => {
        scrollTabElement.forEach((item, index) => {
          item.classList.remove("active");
        });
        floatTabElement.forEach((item, index) => {
          item.classList.remove("active");
        });
        floatTabElement[idx].classList.add("active");
        scrollTabElement[idx].classList.add("active");
        const rem = parseFloat(getComputedStyle(document.documentElement).fontSize);
        const leftPad = 32 * rem;
        const wrapper = document.querySelector(".scrollTabWrapper");
        wrapper.scrollLeft = idx <= 1 ? 0 : e.target.offsetLeft - leftPad;
      };
      const scrollTabElement = document.querySelectorAll(
        ".scrollTabWrapper .tabItem"
      );

      function scrollToElement(target, options = {}) {
        const element = typeof target === 'string' ? document.querySelector(target) : target;
        if (!element) {
          console.warn('目标元素不存在');
          return;
        }

        // 3. 合并默认配置
        const defaultOptions = {
          behavior: 'smooth', // 平滑滚动
          block: 'start',     // 垂直方向对齐: start, center, end, nearest
          inline: 'nearest'   // 水平方向对齐
        };

        // 4. 执行滚动
        element.scrollIntoView({ ...defaultOptions, ...options });
      }

      const floatTabElement = document.querySelectorAll(".floatTab .tabItem");
      floatTabElement.forEach((item, idx) => {
        item.addEventListener("click", function (e) {
          setTabActIdx(idx, e);
          ProductVM.ctx.changeHandle(idx);
          scrollToElement('.liquidityDepth h2')
          setTimeout(() => {
            document
              .querySelector(".product-table.scroll-fade-up")
              .classList.add("in-view");
          }, 500);

        });
      });
      scrollTabElement.forEach((item, idx) => {
        item.addEventListener("click", function (e) {
          setTabActIdx(idx, e);
          ProductVM.ctx.changeHandle(idx);
          setTimeout(() => {
            document
              .querySelector(".product-table.scroll-fade-up")
              .classList.add("in-view");
          }, 500);
        });
      });

      function initStickyObserver(id, onStatusChange) {
        const el = document.getElementById(id);
        if (!el) return console.warn(`ID为 ${id} 的元素不存在`);
        let ticking = false;
        let lastState = null; // 状态锁

        const checkPosition = () => {
          const rect = el.getBoundingClientRect();
          const winHeight = window.innerHeight;

          if (rect.bottom < 0) {
            updateState(true);
            ticking = false;
            return;
          }

          if (rect.top > winHeight) {
            updateState(false);
            ticking = false;
            return;
          }

          const totalDistance = rect.height - winHeight;
          const scrolled = -rect.top;
          const progress = scrolled / totalDistance;

          const isOverHalf = progress >= 0.5;

          updateState(isOverHalf);
          ticking = false;
        };
        checkPosition()
        function updateState(currentState) {
          if (currentState !== lastState) {
            lastState = currentState;
            if (typeof onStatusChange === 'function') {
              onStatusChange(currentState);
            }
          }
        }

        // 绑定事件
        window.addEventListener('scroll', () => {
          if (!ticking) {
            window.requestAnimationFrame(checkPosition);
            ticking = true;
          }
        }, { passive: true });
      }


      window.matchMedia('(min-width:996px)').matches && initStickyObserver('tradeBlack', (isOverHalf) => {
        if (isOverHalf) {
          document.querySelector('.tradeBlackBox .firstPage').style.display = 'none';
          document.querySelector('.tradeBlackBox .secondPage').style.display = 'flex';
        } else {
          document.querySelector('.tradeBlackBox .firstPage').style.display = 'flex';
          document.querySelector('.tradeBlackBox .secondPage').style.display = 'none';
        }
      });

    }
  }
}
</script>

<style scoped lang="scss">
#pageOverLay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  display: none;
  opacity: 0;
  transition: opacity 0.6s ease;
}

.technologyHead {
  padding-left: calc(50vw - 600rem);
  gap: 178rem;
  padding-top: 101rem;
  height: 560rem;
  background: var(--ebc-neutral-bg_c);
}

.liquidityDepth a:hover,
.tradeBlackBox a:hover,
.orderTransfer a:hover,
.technologyHead a:hover,
.techPowerTrade a:hover {
  color: #fff !important;
}

.technologyHeadMain {
  flex: 0 0 588rem;
  padding-top: 59rem;
}

.technologyHeadMain h2 {
  margin: 24rem 0 64rem;
  color: var(--ebc-text-secondary);
}

.technologyHeadBtn {
  width: fit-content;
  min-width: 180rem;
  gap: 5rem;
}

.technologyHeadModel {
  width: 530rem;
  height: auto;
}

.contentBox {
  max-width: 1200rem;
  margin-inline: auto;
}

.MapLabel {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 0.5px solid var(--Neutral-Stroke, rgba(0, 0, 0, 0.12));
  background: #FFF;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.08);
  color: var(--Text-Secondary, rgba(0, 0, 0, 0.64));
  /* Footnote/Regular_12 */
  font-size: 9px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px;
  /* 166.667% */
}

@media (min-width: 996px) {
  .ar .technologyHead {
    padding-left: 0;
    padding-right: calc(50vw - 600rem);
  }

  .ug .technologyHeadMain,
  .ar .technologyHeadMain,
  .pt .technologyHeadMain,
  .mn .technologyHeadMain,
  .id .technologyHeadMain,
  .vi .technologyHeadMain,
  .es .technologyHeadMain,
  .th .technologyHeadMain,
  .en .technologyHeadMain {
    flex: 0 0 758rem;
    position: relative;
    z-index: 2;
  }

  .mn .technologyHeadMain h1 {
    font-size: 64rem;
  }

  .ru .technologyHeadMain h1 {
    font-size: 70rem;
    line-height: 74rem;
  }

  .ru .technologyHeadMain h2 {
    margin-bottom: 40rem;
  }

  .pt .technologyHeadMain h1,
  .es .technologyHeadMain h1 {
    font-size: 70rem;
  }

  .id .technologyHeadMain h1,
  .th .technologyHeadMain h1,
  .en .technologyHeadMain h1 {
    font-size: 72rem;
  }

  .ug .technologyHeadMain h1,
  .vi .technologyHeadMain h1 {
    font-size: 74rem;
  }

  .ar .technologyHeadModel {
    margin-right: -170rem;
    margin-left: unset;
  }

  .ug .technologyHeadModel,
  .mn .technologyHeadModel,
  .pt .technologyHeadModel,
  .vi .technologyHeadModel,
  .id .technologyHeadModel,
  .th .technologyHeadModel,
  .es .technologyHeadModel,
  .en .technologyHeadModel {
    margin-left: -170rem;
  }

  .technologyHeadMain h2 {
    max-width: 700rem;
  }

  .techPowerTrade h3 {
    max-width: 1200rem;
  }
}

@media (max-width: 996px) {
  .MapLabel {
    font-size: 16px;
  }

  .contentBox {
    max-width: 100%;
    padding-inline: 32rem;
  }

  .technologyHead {
    height: auto;
    padding: 34rem 32rem 80rem;
    overflow: hidden;
    flex-direction: column;
    text-align: center;
    gap: 56rem;
  }

  .technologyHeadModel {
    width: auto;
    height: 528rem;
    max-width: unset;
    margin-left: -40rem;
  }

  .ar .technologyHeadModel {
    margin-left: unset;
    margin-right: -40rem;
  }

  .technologyHeadMain {
    padding-top: 0rem;
  }

  .technologyHeadMain {
    order: 2;
    flex: 1;
  }

  .technologyHeadBtn {
    width: 100%;
    gap: 8rem;
  }
}

.techPowerTrade {
  padding: 120rem 0;
  text-align: center;
}

.techPowerTrade h3 {
  margin: 16rem auto 0rem;
  position: relative;
  z-index: 2;
}

#worldMap {
  width: 1400rem;
  margin-inline: auto;
  margin-top: -20rem;
  position: relative;
}

#worldMap img {
  width: 100%;
  height: auto;
}

#worldMap .pointerShadow {
  position: absolute;
  width: 10rem;
  height: 10rem;
  border-radius: 50%;
  background: rgba(165, 41, 51, 0.40);
  animation: scope 2s infinite;
  z-index: 2;
  transform-origin: center center;
}

#worldMap .wordList .word {
  position: absolute;
  padding: 4rem 8rem;
  border-radius: 4px;
  border: 0.5px solid var(--Neutral-Stroke, rgba(0, 0, 0, 0.12));
  background: #FFF;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.08);
  color: var(--ebc-text-secondary);
}

#worldMap .pointer {
  position: absolute;
  width: 10rem;
  height: 10rem;
  border-radius: 50%;
  background: var(--ebc-basecolor-active-500);
  z-index: 3;
}

.pointer1,
.pointerShadow1 {
  left: 405rem;
  top: 286rem;
}

#worldMap .wordList .word1 {
  left: 386rem;
  top: 310rem;
}

#worldMap .wordList .word2 {
  left: 645rem;
  top: 305rem;
}

#worldMap .wordList .word3 {
  left: 1070rem;
  top: 545rem;
}

#worldMap .wordList .word4 {
  left: 1095rem;
  top: 435rem;
}

#worldMap .wordList .word5 {
  left: 1200rem;
  top: 320rem;
}

.pointer2,
.pointerShadow2 {
  left: 663rem;
  top: 280rem;
}

.pointer3,
.pointerShadow3 {
  left: 1087rem;
  top: 520rem;
}

.pointer4,
.pointerShadow4 {
  left: 1110rem;
  top: 410rem;
}

.pointer5,
.pointerShadow5 {
  left: 1216rem;
  top: 294rem;
}

@keyframes scope {
  0% {
    transform: scale(1.2);
    opacity: 1;
  }

  50% {
    transform: scale(2);
    opacity: .6;
  }

  100% {
    transform: scale(1.2);
    opacity: 1;
  }
}

#worldMap text {
  fill: var(--ebc-text-secondary);
  font-size: 8rem;
  font-weight: 400;
  padding: 4rem 8rem;
  border-radius: 4px;
  border: 0.5px solid var(--Neutral-Stroke, rgba(0, 0, 0, 0.12));
  background: #FFF;
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.08);
}

.techPowerTradeMain {
  position: relative;
}

.techPowerTradeBtn {
  margin-inline: auto;
  width: fit-content;
  min-width: 104rem;
  position: relative;
  margin-top: -40rem;
  z-index: 3;
}

.topShadow {
  position: absolute;
  top: 0px;
  width: 100%;
  height: 100px;
  background: linear-gradient(to top,
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0.9));
}

.bottomShadow {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 250rem;
  background: linear-gradient(to top,
      rgba(255, 255, 255, 0.95),
      rgba(255, 255, 255, 0.1));
}

.techPowerTradeStatic {
  position: absolute;
  z-index: 2;
  width: 1200rem;
  left: 50%;
  bottom: 90rem;
  transform: translateX(-50%);
}

.staticPart {
  flex: 1;
  text-align: center;
}

.techPowerTrade h3 {
  color: var(--ebc-text-secondary);
}

.staticPart div:nth-child(2) {
  margin-top: 16rem;
  color: var(--ebc-text-secondary);
}

@media (max-width: 996px) {
  .techPowerTrade {
    overflow: hidden;
    padding: 160rem 32rem 110rem;
  }

  .techPowerTradeStatic {
    flex-wrap: wrap;
  }

  .techPowerTrade h3 {
    margin-bottom: 80rem;
    padding: 0 !important;
  }

  .staticPart {
    flex: 0 0 342rem;
    row-gap: 48rem;
  }

  #worldMap {
    width: 1000rem;
    margin-left: -212rem;
    position: relative;
  }

  #worldMap .pointerShadow {
    position: absolute;
    width: 16rem;
    height: 16rem;
    border-radius: 50%;
    background: rgba(165, 41, 51, 0.40);
    animation: scope 2s infinite;
    z-index: 2;
    transform-origin: center center;
  }

  #worldMap .wordList .word {
    position: absolute;
    padding: 4rem 8rem;
    border-radius: 4px;
    border: 0.5px solid var(--Neutral-Stroke, rgba(0, 0, 0, 0.12));
    background: #FFF;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.08);
    color: var(--ebc-text-secondary);
  }

  #worldMap .pointer {
    position: absolute;
    width: 16rem;
    height: 16rem;
    border-radius: 50%;
    background: var(--ebc-basecolor-active-500);
    z-index: 3;
  }



  #worldMap .wordList .word1 {
    left: 255rem;
    top: 240rem;
  }

  #worldMap .wordList .word2 {
    left: 440rem;
    top: 230rem;
  }

  #worldMap .wordList .word3 {
    left: 730rem;
    top: 400rem;
  }

  #worldMap.en .wordList .word4 {
    left: 770rem;
  }

  #worldMap .wordList .word4 {
    left: 790rem;
    top: 318rem;
  }

  #worldMap .wordList .word5 {
    left: 832rem;
    top: 240rem;
  }

  .pointer1,
  .pointerShadow1 {
    left: 286rem;
    top: 204rem;
  }

  .pointer2,
  .pointerShadow2 {
    left: 468rem;
    top: 200rem;
  }

  .pointer3,
  .pointerShadow3 {
    left: 772rem;
    top: 366rem;
  }

  .pointer4,
  .pointerShadow4 {
    left: 792rem;
    top: 288rem;
  }

  .pointer5,
  .pointerShadow5 {
    top: 212rem;
    left: 860rem;
  }

  .ar #worldMap {
    margin-left: unset;
    margin-right: -80rem;
  }

  .topShadow {
    width: 110vw;
    left: -10vw;
    height: 30px;
  }

  .bottomShadow {
    bottom: 200rem;
  }

  #worldMap {
    margin-top: 20rem;
  }


  .techPowerTradeMain {
    position: relative;
  }

  .techPowerTradeMain .techPowerTradeStatic {
    position: static;
    width: 100%;
    row-gap: 40rem;
    transform: translate(0, -50rem);
    align-items: flex-start !important;

  }

  .ar .techPowerTradeStatic {
    justify-content: center;
  }
}

.tradeBlackBox {
  background: #000;
  text-align: center;
  position: relative;
  height: 160vh;
  min-height: 1600px;
}

.tradeBlackBox h2 {
  color: var(--ebc-text-primary_white);
}

.tradeBlackBox h3 {
  color: var(--ebc-text-secondary_white);
  padding: 16rem 0 80rem;

}

.tradeBlackBox .contentBox {
  padding-block: 120rem;
  position: sticky;
  top: 80px;
}

.tradeBlackStickyPage .pageDescription {
  color: var(--ebc-text-secondary_white);
  margin: 9rem 0 64rem;
}

.innerPagenavigation {
  gap: 8rem;
  padding-block: 15rem;
  cursor: pointer;
}

.innerPagenavigation div {
  height: 4px;
  border-radius: var(--ebc-corner-radius-full);
  background: var(--ebc-neutral-divider_medium_white);
  width: 32px;
  cursor: pointer;
}

.innerPagenavigation .active {
  background: var(--ebc-text-primary_white);
  width: 64px;
}

.tradeBlackBtn {
  width: fit-content;
  min-width: 164rem;
  gap: 6rem;
}

.tradeBlackStickyPage {
  text-align: left;
  height: 650rem;
}

.tradeBlackStickyPage .pageContent {
  flex: 0 0 486rem;
}

.tradeBlackStickyPage.secondPage .pageModel {
  position: relative;
}

.locationWord {
  position: absolute;
  font-size: 13.5px;
  line-height: 20px;
  font-weight: 400;
  color: var(--ebc-text-secondary_white);
}

.zh .locationWord1 {
  width: 23px;
  left: -26px;
  top: 0;
  text-align: center;
}

.locationWord1 {
  top: -25px;
  left: 0;
}

.locationWord2 {
  right: 0;
  bottom: -25px
}

.tradeBlackStickyPage.secondPage .pageModel img {
  width: 570rem;
  height: auto;
}

.firstPage .pageModel img {
  width: 600rem;
  height: auto;
}

@media (max-width: 996px) {
  .tradeBlackBox {
    padding: 0;
    height: auto;
    min-height: unset;
  }

  .tradeBlackBox .contentBox {
    padding: 160rem 32rem 210rem;
  }

  .innerPagenavigation {
    display: none !important;
  }

  .tradeBlackStickyPage {
    flex-direction: column;
    text-align: center;
    height: auto;
  }

  .pageContent {
    /* order: 2; */
  }

  .locationWord {
    font-size: 12px;
  }

  .firstPage .pageContent {
    margin-bottom: 48rem;
    flex: 1;
  }

  .firstPage .pageModel img {
    width: 100%;
    height: auto;
  }

  .secondPage .pageContent {
    margin: 96rem 0;
    flex: 1;
  }

  .tradeBlackStickyPage.secondPage .pageModel {
    margin-left: 20rem;
  }

  .tradeBlackStickyPage.secondPage .pageModel img {
    width: 620rem;
  }

  .tradeBlackStickyPage .pageDescription {
    margin: 0
  }

  .tradeBlackStickyPage .tradeBlackBtn {
    display: none;
  }

  .tradeBlackBox .mobileTradeBlackBtn {
    margin-bottom: 80rem;
    height: 80rem;
    gap: 9rem;
    width: fit-content;
    margin-inline: auto;
    font-size: 28rem !important;
    line-height: 1;
  }
}

.orderTransfer {
  padding: 120rem 0;
  background: var(--ebc-neutral-bg_b);
}

.orderTransfer h3 {
  color: var(--ebc-text-secondary);
  margin: 16rem 0 60rem;
}

.orderTransfer img {
  width: 100%;
  height: auto;
}

.orderTransferModel {
  margin-top: 60rem;
}

@media (max-width: 996px) {
  .orderTransfer {
    padding: 160rem 0;
  }

  .orderTransfer h3 {
    margin-bottom: 80rem;
  }

  .orderTransfer .contentBox {
    padding-inline: 0rem;
  }

  .orderTransfer h2 {
    padding-inline: 32rem;
  }

  .orderTransferModel {
    overflow-x: auto;
    margin-top: 80rem;
    padding-inline: 32rem;
  }

  .orderTransferModel::-webkit-scrollbar {
    display: none;
  }

  /* 伪滚动条容器 */
  .fake-scrollbar {
    height: 4px;
    background: #fff;
    border-radius: 2px;
    pointer-events: none;
    /* 只看不点 */
    margin-inline: 32rem;

  }

  /* 伪滑块 */
  .fake-thumb {
    height: 100%;
    background: rgba(0, 0, 0, .5);
    border-radius: 2px;
    width: 0;
    /* js 动态算 */
    transition: width 0.2s;
  }

  .orderTransfer img {
    height: 620px;
    width: auto;
    max-width: unset;
  }
}

.liquidityDepth {
  padding: 120rem 0;
}

.liquidityDepth h3 {
  color: var(--ebc-text-secondary);
  margin: 16rem 0 60rem;
}

.floatTab {
  position: sticky;
  z-index: 98;
  top: 128px;
  margin-inline: auto;
  background: var(--ebc-basecolor-white-85);
  border-radius: var(--ebc-corner-radius-full);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.05);
  backdrop-filter: blur(10px);
  padding: 4rem;
  gap: 8rem;
  width: 792rem;
  height: 64rem;
  opacity: 0;
}

.floatTab .tabItem {
  flex: 1;
  color: var(--ebc-text-secondary);
}

.floatTab .active {
  border-radius: var(--ebc-corner-radius-full);
  background: var(--ebc-neutral-bg_c);
  color: var(--ebc-text-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-weight: 500;
}

@media (max-width: 996px) {
  .floatTab {
    display: none !important;
  }

  .scrollTab {
    display: inline-flex;
    gap: 16rem;
    min-width: fit-content;
  }

  .scrollTabWrapper {
    overflow-x: auto;
    scroll-behavior: smooth;
    padding: 16rem 32rem;
    margin-top: 64rem;
    background: var(--ebc-neutral-bg_a);
    position: sticky;
    top: 44px;
    z-index: 99
  }

  #productModule {
    margin-top: 32rem !important;
  }

  .scrollTabWrapper::-webkit-scrollbar {
    display: none;
  }

  .scrollTab .tabItem {
    color: var(--ebc-text-secondary);
    padding: 16rem 32rem;
    flex: 1;
    background: var(--ebc-neutral-bg_b);
    border-radius: var(--ebc-corner-radius-full);
    white-space: nowrap;
  }

  .scrollTab .active {
    background: var(--ebc-basecolor-active-500);
    color: var(--ebc-text-primary_white);
    font-weight: 500;
  }

  .liquidityDepth {
    padding: 160rem 0;
  }

  .liquidityDepth h3 {
    margin-bottom: 80rem;
  }
}
</style>
